module.exports = __webpack_public_path__ + "img/sad_panda1.710a5c2b.gif";